import PropTypes from 'prop-types';
import { cx } from 'ramda-extension';

import Cross from '@gef-ui/components/atoms/SvgIcon/Icons/Cross';

import AvatarHead from 'components/atoms/CustomSVGIcon/AvatarHead';

export const PillAvatar = ({ name, type = 'blue', onClose }) => {
	const isBlue = type === 'blue';

	return (
		<div className={cx('PillAvatar', { 'PillAvatar--blue': isBlue })}>
			<div className="PillAvatar__avatar">
				<AvatarHead />
			</div>
			<div className="PillAvatar__title">{name}</div>
			<div
				className={cx('PillAvatar__cross', {
					'PillAvatar__cross--blue': isBlue,
					'PillAvatar__cross--gray': !isBlue,
				})}
				onClick={onClose}
			>
				<Cross style={{ fontSize: '10px' }} />
			</div>
		</div>
	);
};

PillAvatar.propTypes = {
	name: PropTypes.string,
	onClose: PropTypes.func,
	type: PropTypes.string,
};

export default PillAvatar;
